import React from 'react';
import useStyle from './loginLayout.style';
import { ContainerFullWidth } from '../ContainerFullWidth';
import { AppVersionBlock } from 'components/molecules/Blocks/AppVersionBlock';

export const LoginLayout = ({ children }) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <ContainerFullWidth>{children}</ContainerFullWidth>
      <footer className={classes.footer}>
        <AppVersionBlock variant="light" />
      </footer>
    </div>
  );
};
